import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import { getExpanses, deleteExpanse } from '../../../Utility/Api';
import { Deletemodel } from "../../Common/Functions";
import { getFormattedCurrentDate2, isReadonlyRoute, NaviGate, shop_id } from '../../../Utility/function';
import AddExpenseForm from './AddExpenseForm';
import { useLocation } from 'react-router-dom';
import { WarehouseContext } from '../../../Utility/UserContext';

const Expanse = () => {
    const { shopItem } = useContext(WarehouseContext);
    const [companyInfo, setCompanyInfo] = useState({
        name: "Company Name",
        address: "123 Business Street, City, State 12345",
        phone: "(123) 456-7890",
        email: "info@yourcompany.com"
    });

    useEffect(() => {
        if (shopItem) {
            setCompanyInfo({
                name: shopItem?.shop_title || shopItem?.title || "",
                address: shopItem?.Address || "",
                phone: shopItem?.phone1 || "",
                email: shopItem?.email || ""
            });
        }
    }, [shopItem]);

    const getOneMonthAgoDate = () => {
        const d = new Date();
        d.setMonth(d.getMonth() - 1);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const getFileUrl = (file) => {
        if (!file) return "";
        if (file.startsWith("http://") || file.startsWith("https://")) {
            return file;
        }
        const cleanPath = file.startsWith("/") ? file.substring(1) : file;
        
        const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
        const baseUrl = isLocal ? "http://127.0.0.1:8000" : "http://193.203.162.101:8002";

        if (cleanPath.startsWith("media/")) {
            return `${baseUrl}/${cleanPath}`;
        }
        return `${baseUrl}/media/${cleanPath}`;
    };

    const [expanses, setExpanses] = useState([]);
    const [expansesData, setExpansesData] = useState();
    const [showModal, setShowModal] = useState(false);
    const [deleteModal, showDeleteModal] = useState(false);
    const [deleteID, setDeleteID] = useState("");
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [in_or_out, setIn_or_out] = useState(0);
    const [activeTab, setActiveTab] = useState(() => {
        return window.location.pathname === "/capital" ? "capital" : "other_expenses";
    });
    const [fromDate, setFromDate] = useState(getOneMonthAgoDate());
    const [toDate, setToDate] = useState(getFormattedCurrentDate2());
    const unitsPerPage = 10;
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [remark, setRemark] = useState("");
    const [selectedExpenseType, setSelectedExpenseType] = useState("");
    const [allExpenseTypes, setAllExpenseTypes] = useState([]);

    useEffect(() => {
        const fetchAllExpenseTypes = async () => {
            try {
                const response = await getExpanses(`shop_id=${shop_id}`);
                if (response?.data?.data) {
                    const uniqueRecorded = [];
                    const seen = new Set();
                    response.data.data.forEach(item => {
                        const title = item.title ? item.title.trim() : "";
                        if (title && title !== "Capital" && !seen.has(title.toLowerCase())) {
                            seen.add(title.toLowerCase());
                            uniqueRecorded.push(title);
                        }
                    });
                    const sorted = uniqueRecorded.sort((a, b) => a.localeCompare(b));
                    setAllExpenseTypes(sorted);
                }
            } catch (error) {
                console.error("Error fetching all expense types:", error);
            }
        };
        if (shop_id) {
            fetchAllExpenseTypes();
        }
    }, [shop_id, showModal]);

    useEffect(() => {
        fetchExpanses(currentPage);
    }, [currentPage, activeTab, fromDate, toDate]);

    useEffect(() => {
        if (pathname === "/capital") {
            setActiveTab("capital");
        } else if (pathname === "/expense") {
            setActiveTab("other_expenses");
        }
        setSelectedExpenseType("");
    }, [pathname]);

    const fetchExpanses = async (page) => {
        try {
            var filter = `from_date=${fromDate}&to_date=${toDate}&shop_id=${shop_id}`;
            const response = await getExpanses(filter);
            if (response.data && response.data.data) {
                setExpanses(response.data.data);
                setExpansesData(response.data);
            }
        } catch (error) {
            console.error('Error fetching Expanse data:', error);
        }
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        const printContent = document.getElementById('printable-report').innerHTML;
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>${activeTab === "capital" ? "Capital Report" : "Expense Report"}</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        font-size: 11pt;
                        color: #000;
                        background: #fff;
                        padding: 20px;
                    }
                    .print-container {
                        width: 100%;
                        margin: 0 auto;
                    }
                    .print-header {
                        text-align: center;
                        margin-bottom: 20px;
                        border-bottom: 2px solid #000;
                        padding-bottom: 15px;
                    }
                    .print-header h1 {
                        font-size: 20pt;
                        margin: 0;
                        color: #000;
                    }
                    .print-header p {
                        margin: 5px 0;
                        font-size: 10pt;
                    }
                    .report-info {
                        margin: 15px 0;
                        padding: 10px;
                        background-color: #f8f9fa;
                        border-radius: 5px;
                    }
                    .report-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 15px 0;
                        font-size: 10pt;
                    }
                    .report-table th, .report-table td {
                        border: 1px solid #ddd;
                        padding: 8px;
                        text-align: left;
                    }
                    .report-table th {
                        background-color: #f2f2f2;
                        font-weight: bold;
                    }
                    .text-success {
                        color: #28a745 !important;
                        font-weight: bold;
                    }
                    .text-danger {
                        color: #dc3545 !important;
                        font-weight: bold;
                    }
                    .footer {
                        margin-top: 30px;
                        text-align: center;
                        font-size: 9pt;
                        color: #6c757d;
                    }
                </style>
            </head>
            <body>
                ${printContent}
                <script>
                    window.onload = function() {
                        window.print();
                        setTimeout(function() {
                            window.close();
                        }, 100);
                    };
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    const openModal = (unit = null) => {
        setSelectedUnit(unit);
        setShowModal(true);
    };

    const handleDelete = async () => {
        try {
            await deleteExpanse(deleteID);
            toast.success('Expense deleted successfully');
            fetchExpanses(currentPage);
            showDeleteModal(false);
        } catch (error) {
            console.error('Error deleting unit:', error);
        }
    };

    const handleDeleteModal = (ID) => {
        showDeleteModal(true);
        setDeleteID(ID);
    };

    const filteredExpanses = expanses.filter(exp => {
        if (activeTab === "petty_cash" && exp.type !== "0") return false;
        if (activeTab === "capital" && !(exp.type === "1" && exp.title == "Capital")) return false;
        if (activeTab === "other_expenses" && exp.type !== "2") return false;
        if (activeTab === "deduction" && exp.type !== "3") return false;
        
        if (selectedExpenseType && exp.title !== selectedExpenseType) return false;
        
        return true;
    });

    const sortedExpanses = [...filteredExpanses].sort((a, b) => {
        const dateA = new Date(a.date + 'T00:00:00');
        const dateB = new Date(b.date + 'T00:00:00');
        if (dateB - dateA !== 0) {
            return dateB - dateA;
        }
        return (parseInt(b.id) || 0) - (parseInt(a.id) || 0);
    });

    const indexOfLastUnit = currentPage * unitsPerPage;
    const indexOfFirstUnit = indexOfLastUnit - unitsPerPage;
    const totalPages = Math.ceil(sortedExpanses?.length / unitsPerPage);
    const currentData = sortedExpanses.slice(indexOfFirstUnit, indexOfLastUnit);


    const capitalData = {
        capital: {
            label1: "Total Capital",
            value1: expansesData?.total_capital,
            // label2: "Balance",
            // value2: expansesData?.remain_capital
        },
        petty_cash: {
            label1: "Total Petty Cash",
            value1: expansesData?.total_petty,
            label2: "Remaining",
            value2: expansesData?.remaining_petty,
            showButton: true
        }
    };

    const selectedData = capitalData[activeTab];

    const handleReturnClick = () => {
        setIsModalOpen(true);
    };

    const submitReturnToBank = async () => {
        try {
            // Example API call
            await ("/api/return-petty-cash", {
                amount: expansesData?.remaining_petty,
                remark,
            });

            setRemark("");
            setIsModalOpen(false);
            alert("Amount returned successfully!");

            fetchExpanses();
        } catch (err) {
            console.error(err);
        }
    };


    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                {/* <h6 className="mb-0 text-uppercase">Expense List</h6> */}
                <h6 className="mb-0 text-uppercase">
                    {activeTab === "capital" ? "Capital List" : "Expense List"}
                </h6>
                <hr />
                <div className="d-flex mb-3 justify-content-between">
                    {/* <div>
                        <button
                            className={`btn ${activeTab === "petty_cash" ? "btn-success" : "btn-outline-success"} me-2`}
                            onClick={() => setActiveTab("petty_cash")}
                        >
                            Petty Cash
                        </button>
                        <button
                            className={`btn ${activeTab === "capital" ? "btn-success" : "btn-outline-success"} me-2`}
                            onClick={() => setActiveTab("capital")}
                        >
                            Capital
                        </button>
                        <button
                            className={`btn ${activeTab === "other_expenses" ? "btn-success" : "btn-outline-success"}  me-2`}
                            onClick={() => setActiveTab("other_expenses")}
                        >
                            Other Expenses
                        </button>
                    </div> */}

                    {/* {activeTab !== "capital" && (
                        <div>
                            <button
                                className={`btn ${activeTab === "petty_cash" ? "btn-success" : "btn-outline-success"} me-2`}
                                onClick={() => setActiveTab("petty_cash")}
                            >
                                Petty Cash
                            </button>
                            <button
                                className={`btn ${activeTab === "other_expenses" ? "btn-success" : "btn-outline-success"}  me-2`}
                                onClick={() => setActiveTab("other_expenses")}
                            >
                                Other Expenses
                            </button>
                        </div>
                    )} */}

                    {activeTab !== "capital" ? (
                        <div>
                            <button
                                className={`btn ${activeTab === "other_expenses" ? "btn-success" : "btn-outline-success"}  me-2`}
                                onClick={() => setActiveTab("other_expenses")}
                            >
                                Expenses
                            </button>
                        </div>
                    ) : <div />}

                    {!readonly && (<>
                        {activeTab != "deduction" && (
                            <div className="">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setIn_or_out(activeTab === "capital" ? "0" : "1")
                                        openModal()
                                    }}
                                    className="btn btn-primary m-2"
                                    style={{ fontFamily: "poppins" }}>
                                    {activeTab === "capital" ? "Add Amount" : "Record Expense"}
                                </button>
                            </div>
                        )} </>)}
                </div>

                <div className="card">
                    <div className="card-body">
                        {/* {selectedData && ( */}
                        <div className="d-flex mb-1 justify-content-between align-items-center">
                            <div>
                                {/* {selectedData ?
                                    <>
                                        <p className='mb-1'>{selectedData?.label1}: <strong className="font-18">{selectedData?.value1}</strong></p>
                                        <p className='mb-0'>{selectedData?.label2}: <strong className="font-18">{selectedData?.value2}</strong></p>

                                    </> : <></>} */}
                                {selectedData && (
                                    <>
                                        <p className="mb-1">
                                            {selectedData.label1}:
                                            <strong className="font-18 ms-1">{selectedData.value1}</strong>
                                        </p>

                                        {activeTab === "petty_cash" ? (
                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className="mb-0">
                                                    {selectedData.label2}:
                                                    <strong className="font-18 ms-1 mb-1 me-2">{selectedData.value2}</strong>
                                                </p>

                                                {/* <button
                                                    className="btn btn-outline-primary btn-sm"
                                                    disabled={!selectedData.value2}
                                                    onClick={() => setIsModalOpen(true)}
                                                >
                                                    Return
                                                </button> */}
                                            </div>
                                        ) : (
                                            <>
                                                {selectedData.label2 && (
                                                    <p className="mb-0">
                                                        {selectedData.label2}:
                                                        <strong className="font-18 ms-1">{selectedData.value2}</strong>
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}

                            </div>
                            <div className='d-flex gap-2 align-items-center'>
                                {activeTab !== "capital" && (
                                    <div className="form-floating" style={{ minWidth: "200px" }}>
                                        <select
                                            className="form-select"
                                            id="expenseTypeFilter"
                                            value={selectedExpenseType}
                                            onChange={(e) => setSelectedExpenseType(e.target.value)}
                                        >
                                            <option value="">All Expense Types</option>
                                            {allExpenseTypes.map((type, idx) => (
                                                <option key={idx} value={type}>
                                                    {type}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="expenseTypeFilter">Expense Type</label>
                                    </div>
                                )}

                                <div className="form-floating">
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="fromDate"
                                        value={fromDate}
                                        max={toDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                    />
                                    <label htmlFor="fromDate">From Date</label>
                                </div>

                                <div className="form-floating">
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="toDate"
                                        value={toDate}
                                        min={fromDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                    />
                                    <label htmlFor="toDate">To Date</label>
                                </div>

                                <button
                                    type="button"
                                    className="btn btn-dark px-4 fw-semibold"
                                    onClick={handlePrint}
                                    style={{ height: "58px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                >
                                    Print
                                </button>
                            </div>
                        </div>
                        {/* )} */}


                        {/* {activeTab == "capital" && <div className="d-flex mb-1 justify-content-between">
                            <p>Total Capital : <strong className='font-18'>{expansesData?.total_capital}</strong></p>
                            <p>Balance : <strong className='font-18'>{expansesData?.remain_capital}</strong></p>
                        </div>}
                        {activeTab == "petty_cash" &&
                            <div className="d-flex mb-1 justify-content-between">
                                <p>Total Petty Cash : <strong className='font-18'>{expansesData?.total_petty}</strong></p>
                                <p>Remaining : <strong className='font-18'>{expansesData?.remaining_petty}</strong></p>
                            </div>} */}

                        <div className="table-responsive" style={{ width: "100%" }}>
                            <table className="table table-striped table-bordered align-middle text-center" style={{ fontFamily: "Poppins", minWidth: "1000px", width: "100%" }}>
                                <thead className="table-dark">
                                    <tr>
                                        <th style={{ width: "5%", minWidth: "60px" }}>S.No</th>
                                        <th style={{ width: "12%", minWidth: "110px" }}>Date</th>
                                        <th style={{ width: "23%", minWidth: "160px" }}>Account</th>
                                        <th style={{ width: "28%", minWidth: "200px" }}>Remark</th>
                                        <th style={{ width: "11%", minWidth: "110px" }}>Credit (Ro)</th>
                                        <th style={{ width: "11%", minWidth: "110px" }}>Debit (Ro)</th>
                                        <th style={{ width: "5%", minWidth: "85px" }}>Receipt</th>
                                        {!readonly && (<th style={{ width: "5%", minWidth: "90px" }}>Actions</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((entry, index) => (
                                        <tr key={entry.id}>
                                            <td>{(currentPage - 1) * unitsPerPage + index + 1}</td>
                                            <td>{entry.date}</td>
                                            <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{entry.title}</td>
                                            <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{entry.remark}</td>
                                            <td className="text-success fw-bold">{entry.in_or_out == "0" ? entry.amount : "-"}</td>
                                            <td className="text-danger fw-bold">{entry.in_or_out == "1" ? entry.amount : "-"}</td>
                                            <td>
                                                {entry.file ? (
                                                    <a
                                                        href={getFileUrl(entry.file)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 mx-auto justify-content-center"
                                                    >
                                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-blue-600">
                                                            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
                                                            <polyline points="14 2 14 8 20 8"/>
                                                        </svg>
                                                        <span className="text-xs font-semibold text-blue-600">View</span>
                                                    </a>
                                                ) : (
                                                    <span className="text-muted text-xs">-</span>
                                                )}
                                            </td>
                                            {!readonly && (
                                                <>
                                                    <td>
                                                        <img
                                                            src="/assets/images/icons/edit.png"
                                                            onClick={() => openModal(entry)}
                                                            height="20px"
                                                            alt="Edit"
                                                            className="me-1"
                                                        />
                                                        <img
                                                            src="/assets/images/icons/delete.png"
                                                            onClick={() => handleDeleteModal(entry.id)}
                                                            height="20px"
                                                            alt="Delete"
                                                        />
                                                    </td></>)}
                                        </tr>
                                    ))}
                                    <tr className="table-primary" style={{ fontWeight: "bold" }}>
                                        <td colSpan={3}></td>
                                        <td>Total</td>
                                        <td className="text-success">{sortedExpanses?.filter((f) => f.in_or_out == "0").reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)}</td>
                                        <td className="text-danger">{sortedExpanses?.filter((f) => f.in_or_out == "1").reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)}</td>
                                        <td></td>
                                        {!readonly && (
                                            <td />)
                                        }
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination Controls */}
                        <div className="d-flex justify-content-between mt-3">
                            <button
                                className="btn btn-outline-primary"
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(prev => prev - 1)}
                            >
                                Previous
                            </button>
                            <span>Page {currentPage} of {totalPages}</span>
                            <button
                                className="btn btn-outline-primary"
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(prev => prev + 1)}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            {isModalOpen && (
                <>
                    <div className="modal-backdrop fade show"></div>

                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">Return Petty Cash</h5>
                                    <button type="button" className="btn-close"
                                        onClick={() => {
                                            setRemark("");
                                            setIsModalOpen(false);
                                        }}></button>
                                </div>

                                <div className="modal-body">

                                    <div className="alert alert-info p-2 mb-1">
                                        <strong>Amount:</strong> {selectedData?.value2}
                                    </div>
                                    <label className="form-label mb-1">Remark</label>
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        value={remark}
                                        onChange={(e) => setRemark(e.target.value)}
                                        placeholder="Enter remark..."
                                    ></textarea>
                                </div>

                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => { setRemark(""); setIsModalOpen(false); }}>Close</button>
                                    <button className="btn btn-success" onClick={submitReturnToBank}>Submit</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </>
            )}
            {deleteModal && (
                <Deletemodel
                    setShowModal={showDeleteModal}
                    handleDelete={handleDelete}
                />
            )}
            {showModal && (
                <AddExpenseForm
                    showModal={showModal}
                    unit={selectedUnit}
                    closeModal={() => setShowModal(false)}
                    refreshList={() => fetchExpanses(currentPage)}
                    type={activeTab === "petty_cash" ? 0 : activeTab === "capital" ? 1 : 2}
                    in_or_out={in_or_out}
                />
            )}

            {/* Printable Report (Hidden from normal view) */}
            <div id="printable-report" style={{ display: 'none' }}>
                <div className="print-container">
                    <div className="print-header">
                        <h1>{companyInfo.name}</h1>
                        {companyInfo.address && <p>{companyInfo.address}</p>}
                        {(companyInfo.phone || companyInfo.email) && (
                            <p>
                                {companyInfo.phone && `Phone: ${companyInfo.phone}`}
                                {companyInfo.phone && companyInfo.email && " | "}
                                {companyInfo.email && `Email: ${companyInfo.email}`}
                            </p>
                        )}
                        <h2>{activeTab === "capital" ? "Capital Report" : "Expense Report"}</h2>
                    </div>

                    <div className="report-info">
                        <p><strong>Report Period:</strong> {fromDate} to {toDate}</p>
                        <p><strong>Generated On:</strong> {new Date().toLocaleDateString()}</p>
                        <p><strong>Type:</strong> {activeTab === "capital" ? "Capital" : "Expenses"}</p>
                    </div>

                    <table className="report-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Date</th>
                                <th>Account</th>
                                <th>Remark</th>
                                <th>Credit (Ro)</th>
                                <th>Debit (Ro)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedExpanses.length > 0 ? (
                                <>
                                    {sortedExpanses.map((entry, index) => (
                                        <tr key={entry.id}>
                                            <td>{index + 1}</td>
                                            <td>{entry.date}</td>
                                            <td>{entry.title}</td>
                                            <td>{entry.remark}</td>
                                            <td className="text-success">{entry.in_or_out == "0" ? entry.amount : "-"}</td>
                                            <td className="text-danger">{entry.in_or_out == "1" ? entry.amount : "-"}</td>
                                        </tr>
                                    ))}
                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
                                        <td colSpan={4} style={{ textAlign: 'right' }}>Total</td>
                                        <td className="text-success">{sortedExpanses?.filter((f) => f.in_or_out == "0").reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)}</td>
                                        <td className="text-danger">{sortedExpanses?.filter((f) => f.in_or_out == "1").reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)}</td>
                                    </tr>
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: 'center' }}>No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <div className="footer">
                        <p>Report generated on {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Expanse;
